import Head from 'next/head'

import Banner from '@/components/Lending/Banner'
import Benefit from '@/components/Lending/Benefit'
import Customer from '@/components/Lending/Customer'
import Footer from '@/components/Lending/Layout/Footer'
import Header from '@/components/Lending/Layout/Header'
import Partner from '@/components/Lending/Partner'
import Process from '@/components/Lending/Process'
import Support from '@/components/Lending/Support'
import useApplyUrl from '@/hooks/useApplyUrl'

const productPath = process.env.NEXT_PUBLIC_REACT_APP_PRODUCTION_PATH

export default function Home() {
  const loanApplyUrl = useApplyUrl()

  return (
    <>
      <Head>
        <meta charSet="UTF-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width,initial-scale=1.0" />

        <title>
          KiotViet Finance - Giải Pháp thanh toán và vay vốn tiện lợi
        </title>
        <meta
          name="title"
          content="KiotViet Finance - Giải Pháp thanh toán và vay vốn tiện lợi"
        />
        <meta
          name="description"
          content="Giải pháp tài chính cho doanh nghiệp vừa, nhỏ và siêu nhỏ hỗ trợ bạn phát triển và mở rộng kinh doanh."
        />

        {/* <!-- Open Graph / Facebook --/> */}
        <meta property="og:type" content="website" />
        <meta property="og:url"content={productPath || '/'}/>
        <meta
          property="og:title"
          content="KiotViet Finance - Giải Pháp thanh toán và vay vốn tiện lợi"
        />
        <meta
          property="og:description"
          content="Giải pháp tài chính cho doanh nghiệp vừa, nhỏ và siêu nhỏ hỗ trợ bạn phát triển và mở rộng kinh doanh."
        />
        <meta
          property="og:image"
          content={`${productPath|| ''}/images/preview-img.png`}
        />
      </Head>
      <Header loanApplyUrl={loanApplyUrl} />
      <div>
        <Benefit />
        <Process loanApplyUrl={loanApplyUrl}/>
        <Partner />
        <Customer />
        <Banner loanApplyUrl={loanApplyUrl} />
        <Support />
      </div>
      <Footer />
    </>
  )
}
